(function ($) {
	$(function () {
		$("select.years").select2({
			minimumResultsForSearch	:	-1,
			width					:	"100%",
		});

		$("select.years").on("change", function () {
			let termID	=	$(this).val();
			let $targets	=	$(".items > tbody > tr");
			
			$targets.each(function () {
				let $target	=	$(this);

				if($target.attr("data-termID") == termID) {
					$target.addClass("show");
				}
				else {
					$target.removeClass("show");
				}
			});
		}).trigger("change");
	});
})(jQuery);